<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item['quality']" class="hidden-md-and-down">
            <h1><v-icon large>mdi-strategy</v-icon>{{ item['quality'].name }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <ProfileStrategyQualityForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ProfileStrategyQualityForm from '../../components/profilestrategyquality/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'ProfileStrategyQuality';
const routeAfterDel = 'ProfileStrategyUpdate';
const routeAfterDelId = 'profileStrategy';

export default {
  name: 'ProfileStrategyQualityUpdate',
  servicePrefix,
  routeAfterDel,
  routeAfterDelId,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileStrategyQualityForm
  },

  computed: {
    ...mapFields('profilestrategyquality', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('profilestrategyquality', ['find'])

  },

  methods: {
    ...mapActions('profilestrategyquality', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
